import React, { useState, useEffect } from "react";
import { Link, useParams,useNavigate } from "react-router-dom";
import { TabPanel } from 'primereact/tabview';
import TabViewEva from '../../components/TabviewEva/TabviewEva';
import { Timeline } from 'primereact/timeline';
import { ProgressBar } from 'primereact/progressbar';
import HomeEvaluacion from "./EvaluacionDesempeño/HomeEvaluacion";
import Convocatoria from "./ConvocatoriaInterna/Convocatoria";
import Historias from "./HistoriaDeExito/Historias";
import "./Desarrollo.scss"
import useUsuario from "../../hooks/useUsuario";

const Desarrollo = () => {

    const navigate = useNavigate();
    //const { permisos } = useUsuario();
	const {permisos, perfil}= useUsuario();
		console.log("perfil",perfil)
		console.log("permisos",permisos)
    const { indexDefault } = useParams();

    const [permisoEditar, setPermisoEditar] = useState(false);
    const [indexTab, setIndexTab] = useState(0);

    const [tabSelected, setTabSelected] = useState({
        nombre: "Editar evaluación de desempeño",
        navegacion: "EditarEvaluacion"
    });

    // ✔ PERMISO GLOBAL PARA EDITAR (ya NO depende del tab)
    useEffect(() => {
        if (permisos.length > 0) {
            const puedeEditar =
                permisos.includes("editarEvaluaciones") ||
                permisos.includes("editarConvocatorias") ||
                permisos.includes("editarHistorias");

            setPermisoEditar(puedeEditar);

            // Si no puede ver este módulo, lo sacamos
            if (!permisos.includes("vertudesarrollo")) {
                navigate("/");
            }
        }
    }, [permisos]);


    // ✔ Index inicial desde URL
    useEffect(() => {
        if (indexDefault !== undefined) {
            setIndexTab(parseInt(indexDefault));
            cambiarAccion(parseInt(indexDefault), "BACK");
        }
    }, [indexDefault]);


    // ✔ Cambiar pestañas
    const cambiarAccion = (index, origen = "TAB") => {
        switch (index) {
            case 0:
                setTabSelected({
                    nombre: "Editar evaluación de desempeño",
                    navegacion: "EditarEvaluacion"
                });
                break;

            case 1:
                setTabSelected({
                    nombre: "Crear convocatoria",
                    navegacion: "CrearConvocatoria"
                });
                break;

            case 2:
                setTabSelected({
                    nombre: "Crear Historias de éxito",
                    navegacion: "CrearHistoria"
                });
                break;

            default:
                break;
        }

        if (origen === "TAB") {
            navigate("../Desarrollo/" + index);
        }
    };


    // ✔ Generar tabs reales basados en permisos
    const tabList = [];

    if (permisoEditar && permisos.includes("verEvaluaciones")) {
        tabList.push(
            <TabPanel header="Evaluación de desempeño" key="evaluacion">
                <HomeEvaluacion />
            </TabPanel>
        );
    }

    if (permisos.includes("verConvocatorias")) {
        tabList.push(
            <TabPanel header="Convocatoria interna" key="convocatoria">
                <Convocatoria />
            </TabPanel>
        );
    }

    if (permisos.includes("verHistorias")) {
        tabList.push(
            <TabPanel header="Historia de éxito" key="historias">
                <Historias />
            </TabPanel>
        );
    }

    return (
        <div className="eva-dashboard-desarrollo" style={{ marginLeft: 40, width: 1082, margin: "auto" }}>

            {/* HEADER */}
            <div className="eva-dashboard-header header-agrupado" style={{ height: "100%" }}>
                <div className="header">
                    <label>Tu Desarrollo</label>
                </div>

                {permisoEditar && (
                    <div className="header-right">
                        <Link to={tabSelected.navegacion}>{tabSelected.nombre}</Link>
                    </div>
                )}
            </div>

            {/* BODY */}
            <div className="eva-dashboard-desarrollo-body">
                <TabViewEva cambiarAccion={cambiarAccion} indexDefault={indexTab}>
                    {tabList}
                </TabViewEva>
            </div>
        </div>
    );
};

export default Desarrollo;